// @ts-nocheck
/* eslint-disable */
/* GENERATED USING build-GemIcons.ts - DO NOT MODIFY */
import { ReactComponent as LogoSynapse } from '../../../assets/images/Logos/logo-synapse.svg?react';
import { withLogoClass } from '../../withLogoClass';
export const LogoSynapseIcon = /* @__PURE__ */ withLogoClass(LogoSynapse);
